import request from '../../request'

export default {
    actions: {
        // list all services
        getClients(_, parameters) {
            return request.get('clients', {
                params: parameters
            })
        },

        // list all services
        getCreateClient() {
            return request.get('clients/create')
        },

        // client detail page
        showClientDetails(_, id) {
            return request.get('client-details/' + id);
        },

        deleteOrderContract(_, id) {
            return request.post('profile/delete-order-contract/' + id);
        },  

        createDimensions(_, payload) {
            return request.post('create-dimensions', payload);
        },

        updateDimensions(_, payload) {
            return request.put('create-dimensions/' + payload.id, payload)
        },

        getOrderContractById(_, id) {
            return request.get('profile/order-contract/' + id);
        },

        saveOrderContractById(_, payload) {
            return request.post('profile/order-contract/' + payload.id,{
                contract:payload.contract
            });
        },

        sendSMSToClient(_, params) {
            return request.post('send-sms-to-client/' + params.id, {
                message: params.message,
            });
        },

        getClient(_, id) {
            return request.get('clients/' + id)
        },

        // create new service
        createClient(_, payload) {
            return request.post('clients', payload)
        },

        createClientVSelect(_, payload) {
            return request.post('clients?response=vselect', payload)
        },

        // update service
        updateClient(_, payload) {
            return request.put('clients/' + payload.id, payload)
        },

        // delete service
        deleteClient(_, id) {
            return request.delete('clients/' + id)
        },
        uploadImage(_,payload){
            return request.post('clients/uploadimage',payload)
        },
        deleteImage(_,payload){
            return request.post('clients/deleteimage',payload)
        }
    }
}
